import React from 'react';
import { observer } from 'mobx-react';
import { GoToCardWrapper } from '@seedlang/hoc';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import styled from '@emotion/styled';
import Text from 'components/text';
import { Theme } from '@seedlang/constants';
import { deckCardListText, deckCardListTypeName } from '@seedlang/utils';

const Wrapper = styled.div`
  padding: 15px;
`;

const CardRow = styled.div`
  align-items: center;
  background: ${props => props.selected ? '#e8f6fa' : '#f5f5f5'};
  border-left: ${props => props.selected ? `4px solid ${Theme.blue}` : '4px solid transparent'};
  border-radius: 10px;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;
  padding: 10px;

  &:hover {
    background: #e8f6fa;
  }
`;

const CardIndex = styled.div`
  margin-right: 10px;
  width: 24px;
`;

const CardDetails = styled.div`
  flex: 1;
`;

@observer
class GoToCard extends React.Component {

  render() {
    return (
      <Wrapper>
        {
          this.props.cards.map((card, index) => {
            const selected = card.id === this.props.selectedCardId;
            return (
              <CardRow
                key={card.id}
                onClick={() => this.props.onSelectCard(card)}
                selected={selected}
              >
                <CardIndex>
                  <Text
                    bold
                    color="#666"
                    fontSize="13px"
                  >
                    {`${index + 1}.`}
                  </Text>
                </CardIndex>
                <CardDetails>
                  <Text
                    bold
                    color="#333"
                    fontSize="13px"
                  >
                    {deckCardListTypeName(card, this.props.exercises)}
                  </Text>
                  <Text
                    color="#666"
                    fontSize="13px"
                  >
                    {deckCardListText(card, this.props.exercises)}
                  </Text>
                </CardDetails>
              </CardRow>
            );
          })
        }
      </Wrapper>
    );
  }
}

export default ErrorBoundary(GoToCardWrapper(GoToCard));
